import { render } from "./PositionModal.vue?vue&type=template&id=a8b2777e&scoped=true"
import script from "./PositionModal.vue?vue&type=script&lang=js"
export * from "./PositionModal.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./PositionModal.vue?vue&type=style&index=1&id=a8b2777e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8b2777e"]])

export default __exports__